// extracted by mini-css-extract-plugin
module.exports = {"button":"_1cG7lo-A37dwpPjTyQtfBZ"};